export const PAGE_PROCESSLIST_INITIALIZE = 'PAGE_PROCESSLIST_INITIALIZE';
export const PAGE_PROCESSLIST_SEARCHQUERY = 'PAGE_PROCESSLIST_SEARCHQUERY';
export const PAGE_PROCESSLIST_FILTERCATEGORY =
  'PAGE_PROCESSLIST_FILTERCATEGORY';
export const PAGE_PROCESSLIST_FILTERFAVORITES =
  'PAGE_PROCESSLIST_FILTERFAVORITES';
export const PAGE_PROCESSLIST_REQUEST = 'PAGE_PROCESSLIST_REQUEST';
export const PAGE_PROCESSLIST_RECEIVE = 'PAGE_PROCESSLIST_RECEIVE';

export function initialize() {
  return {
    type: PAGE_PROCESSLIST_INITIALIZE
  };
}

export function requestProcessList() {
  return {
    type: PAGE_PROCESSLIST_REQUEST
  };
}

export function receiveProcessList(processes) {
  return {
    type: PAGE_PROCESSLIST_RECEIVE,
    processes
  };
}

export function searchQuery(query) {
  return {
    type: PAGE_PROCESSLIST_SEARCHQUERY,
    query
  };
}

export function filterCategory(category) {
  return {
    type: PAGE_PROCESSLIST_FILTERCATEGORY,
    category
  };
}

export function filterFavorites() {
  return {
    type: PAGE_PROCESSLIST_FILTERFAVORITES
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/ProcessList.js